/**
 * Flèches de piste défilante : défilement d'un pas de carte, boutons
 * désactivés en bout de course. Sert au carrousel best sellers comme à la
 * piste du Mag — même geste, même code.
 *
 * Délégation sur le document plutôt qu'un écouteur par bouton : l'éditeur de
 * thème remplace le HTML de la section à chaque modification de réglage, ce
 * qui décrocherait des écouteurs posés sur les éléments.
 */
const PAS_PAR_DEFAUT = 300;

const PISTES = '.hm-deal-rail, .hm-mag-grid';
const CARTES = '.cat-card, .hm-post';

function railDe(bouton) {
  return bouton.closest('.shopify-section')?.querySelector(PISTES) ?? null;
}

function pas(rail) {
  const carte = rail.querySelector(CARTES);
  // + la gouttière : sans elle, chaque pas dérive d'un cran vers la gauche.
  return carte ? carte.getBoundingClientRect().width + 16 : PAS_PAR_DEFAUT;
}

function majBoutons(rail) {
  const section = rail.closest('.shopify-section');
  if (!section) return;
  const prev = section.querySelector('[data-rail-prev]');
  const next = section.querySelector('[data-rail-next]');
  // La tolérance de 2px absorbe les positions de défilement fractionnaires
  // des écrans à densité élevée, qui laissaient le bouton actif à l'arrêt.
  if (prev) prev.disabled = rail.scrollLeft <= 2;
  if (next) next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
}

document.addEventListener('click', (event) => {
  const bouton = event.target.closest('[data-rail-prev], [data-rail-next]');
  if (!bouton) return;
  const rail = railDe(bouton);
  if (!rail) return;

  const sens = bouton.hasAttribute('data-rail-prev') ? -1 : 1;
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  rail.scrollBy({ left: sens * pas(rail), behavior: reduit ? 'auto' : 'smooth' });
});

document.addEventListener(
  'scroll',
  (event) => {
    const rail = event.target;
    if (rail instanceof Element && rail.matches?.(PISTES)) majBoutons(rail);
  },
  true,
);

const rafraichirTout = () => document.querySelectorAll(PISTES).forEach(majBoutons);

window.addEventListener('resize', rafraichirTout);
document.addEventListener('shopify:section:load', rafraichirTout);
rafraichirTout();
